/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core'
import { PidxGoogleTagManagerIntegrationService } from './pidx-google-tag-manager-integration.service'
import { ComponentClick } from './one-ga-types'

@Directive({
  selector: '[myprofileUiTrack]',
  standalone: false,
})
export class PidxClickTrackingDirective {
  private elementRef = inject(ElementRef)
  private googleTagManagerIntegrationService = inject(PidxGoogleTagManagerIntegrationService)

  @Input('myprofileUiTrack') trackingData!: ComponentClick

  @HostListener('click') onClick() {
    setTimeout(() => {
      const containingForm = this.elementRef.nativeElement.closest('form')

      // Check if click occurred inside a form, if not trigger click
      if (!containingForm) {
        this.googleTagManagerIntegrationService.triggerClickTracking(this.trackingData)
      } else {
        // Check if click occurred inside a form which has a validation directive, if not trigger click
        const formValidationTrackingId = containingForm.getAttribute('myprofileuivalidationtrack')

        if (!formValidationTrackingId || !this.googleTagManagerIntegrationService.hasValidationErrors(formValidationTrackingId)) {
          this.googleTagManagerIntegrationService.triggerClickTracking(this.trackingData)
        } else {
          this.googleTagManagerIntegrationService.trackInvalidInputEntry(formValidationTrackingId)
        }
      }
    }, 250)
  }
}
